import { useEffect } from 'react'

import type { AudienceSummary } from '@/lib/api'

import AudienceDetailContent from './AudienceDetailContent'

export interface AudienceDetailModalProps {
  audienceId: string
  coverImageUrl?: string | null
  initialCanEdit?: boolean
  canPublishMarketplace?: boolean
  onAudienceChanged?: () => void | Promise<void>
  onClose: () => void
  onOpenChat?: (payload: { audienceId: string; audience?: AudienceSummary | null }) => void
  onOpenChatWithTwin?: (twin: {
    personaId: string
    populationId: string
    personaName?: string
    imageUrl?: string
  }) => void
}

export function AudienceDetailModal({
  audienceId,
  coverImageUrl,
  initialCanEdit,
  canPublishMarketplace,
  onAudienceChanged,
  onClose,
  onOpenChat,
  onOpenChatWithTwin,
}: AudienceDetailModalProps) {
  useEffect(() => {
    document.body.style.overflow = 'hidden'
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose()
      }
    }
    document.addEventListener('keydown', onKeyDown)
    return () => {
      document.body.style.overflow = ''
      document.removeEventListener('keydown', onKeyDown)
    }
  }, [onClose])

  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto">
      <div className="fixed inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} />
      <div className="relative z-10 mx-4 my-4 w-full max-w-[1302px] sm:my-10">
        <AudienceDetailContent
          audienceId={audienceId}
          variant="modal"
          onClose={onClose}
          coverImageUrl={coverImageUrl}
          initialCanEdit={initialCanEdit}
          canPublishMarketplace={canPublishMarketplace}
          onAudienceChanged={onAudienceChanged}
          onOpenChat={onOpenChat}
          onOpenChatWithTwin={onOpenChatWithTwin}
        />
      </div>
    </div>
  )
}
